import { coerceLabel } from '../coerce-label';
import { normalizeThousandsSeparators } from '../numeric';
import type { PanelData } from './types';

export function isNumeric(value: unknown): boolean {
  if (typeof value === 'number') return true;
  if (typeof value === 'string') {
    const n = parseFloat(normalizeThousandsSeparators(value));
    return !isNaN(n) && isFinite(n);
  }
  return false;
}

export function toNumber(value: unknown): number {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') return parseFloat(normalizeThousandsSeparators(value));
  return 0;
}

export function detectSeriesColumns(data: PanelData): {
  labelColumn: string;
  seriesColumns: string[];
} {
  const { columns, rows } = data;
  if (columns.length === 0) {
    return { labelColumn: '', seriesColumns: [] };
  }

  const labelColumn = columns[0]!;
  const seriesColumns = columns.slice(1).filter((col) => {
    return rows.some((row) => isNumeric(row[col]));
  });

  return { labelColumn, seriesColumns };
}

export function prepareChartData(
  data: PanelData,
  labelColumn: string,
  seriesColumns: string[],
): Record<string, unknown>[] {
  return data.rows.map((row) => {
    const entry: Record<string, unknown> = {
      [labelColumn]: coerceLabel(row[labelColumn]),
    };
    for (const col of seriesColumns) {
      entry[col] = toNumber(row[col]);
    }
    return entry;
  });
}
